import { fromUtc } from '@/helpers/dateTimeFormatter.js'

export default {
  methods: {
    fromUtc: fromUtc,
    prettyDate(date) {
      return date !== null
        ? fromUtc({ second: 'numeric' })(this.$locale)(this.$timezone)(date)
        : null
    }
  },
}
